import React,{useEffect,useState,useRef} from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import httpClient from '../../../httpClient'
import { useParams,useLocation } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LinearProgress from '@mui/material/LinearProgress'
import EmbedView from './embedView/embedView';
import ChatTemplate from './chatTemplate/chatTemplate'
import './OpenDashboard.css'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Fab from '@mui/material/Fab';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import axios from 'axios';
// import Backdrop from '@mui/material/Backdrop';
import Batch from '../../Batch/Batch';
import Backdrop from '@mui/material/Backdrop';
import BatchWorkflow from '../../BatchWorkflow/BatchWorkflow';
// import { testhttpClient } from '../../httpClient';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const testhttpClient = axios.create({
  baseURL : 'https://vector.cloobot.ai/configuration-script'
})//not able to import testhttpclient service from httpclient.js



const OpenDashboard = () => {  
  let [fullScreenMode,setFullScreenMode] = useState(false);

  // Access the 'id' parameter from the route
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // const curr_page_id= queryParams.get('id');
  let [page_data, setPageData] = useState({});
  const [curr_page_id,setCurrentPageId] = useState(null);
  
  //console.log("check curr_page_id :: ",curr_page_id)
  const [loading1, setLoading1] = useState(true);
  const [formLoading,setFormLoading] = useState(true);
  const [searchKey,setsearchKey] = useState("");
  const [form_sequence_order,set_form_sequence_order] = useState({})
  const [first_obj,set_first_obj] = useState({})
  const [triggerCloseForms, setTriggerCloseForms] = useState(false);
  const [sectionIndex, setSectionIndex] = useState(null);
  const [compType, setCompType] = useState(null);
  let add_additional_keys = (data) =>{
    let out_data = { ...data };
    for (let i = 0; i < out_data.sections.length; i++) {
      for (let j = 0; j < out_data.sections[i].widgets.length; j++) {
        // Create a new object for each widget to avoid modifying the original object
        out_data.sections[i].widgets[j] = {
          ...out_data.sections[i].widgets[j],
          active: false,
        };
      }
    }
    setLoading1(false);
    return out_data;
  };


  const GetPageDataDreamDashPage = (page_id) => {
    //console.log("on call GetPageDataDreamDashPage")
    // useEffect(() => {
      try{
        let payloadGPD = {
          token: localStorage.getItem('vector_token'),
          page_id:page_id
        }
        httpClient.post('/dream-dashboard/get-page-data',payloadGPD )
          .then(response => {
            // console.log('Response dream-dashboard/get-page-data :', response.data);
            let res = response.data
            // console.log('response data :: ',res)
            if (res && res.data && res.data.sections && res.data.sections.length > 0)
            {
              const sections = res.data.sections;
              for (let i = 0; i < sections.length; i++) {
                  const section = sections[i];
                  // console.log('section :: ', section)
                  if (section && section.batch_workflow && section.batch_workflow.length > 0) {
                    const type_id = section.batch_workflow[0].type_id;
                    // navigate(`/Layout/Batch?type_id=${type_id}`);
                  }
              }
            if (res.data === false) {
              //console.log("\n\n Error \n\n")
            } else {
              setPageData(add_additional_keys(res.data))
            }
            }
          })
          .catch(error => {
            console.error('Error 1:', error);
          });
      } catch (error) {
        console.error('Error 2:', error);
        // Handle network or other errors
      }
      // Cleanup function
      return () => {
        //console.log('Component will unmount.');
      };
    // }, []
    // );
  };

  useEffect(() => {
    // Update the current page ID when the URL parameter changes
    setCurrentPageId(queryParams.get('id'));
    GetPageDataDreamDashPage(queryParams.get('id'));
    // console.log('trigger cehck :: ',triggerCloseForms)
    if(triggerCloseForms){
      // console.log('use check :: ')
      // console.log("sectionIndex",sectionIndex,"compType",compType)
      close_forms(sectionIndex,compType)
      setTriggerCloseForms(false);
      setSectionIndex(null);
      setCompType(null);
    }
  }, [queryParams.get('id'),triggerCloseForms]);

  const [notiState, setNotiState] = React.useState({
    notiMessage : 'Sample Message',
    noti_open: false,
    noti_vertical: 'top',
    noti_horizontal: 'right',
    notiSeverity: 'success',
    duration_in_sec : 3000,
  });
  const { noti_vertical, noti_horizontal, noti_open,notiMessage, notiSeverity,duration_in_sec } = notiState;

  function ShowNotification(newState){
    // //console.log("\n\n\n\nClose notification :: ")
    setNotiState({ ...newState, noti_open: true });
  };

  function CloseNotification(){
    setNotiState({ ...notiState, noti_open: false });
  };

  const triggerNotification = (MsgType,Msg,duration_in_sec = 3000) => {
    // //console.log("triggerNotification :: ",MsgType,Msg)
    ShowNotification({ noti_vertical: 'top', noti_horizontal: 'right', notiMessage: Msg,notiSeverity : MsgType, duration_in_sec: duration_in_sec });
  }



  function submit_form (form_link_data,section_index,comp_type,comp_indx){
    console.log('form link data :: ',form_link_data)
    // console.log('indexes :: ',section_index,comp_type,comp_indx)
    let view_form_obj = {}
    if(form_link_data!=null){
       view_form_obj = {
        active:true,
        type:'form',
        type_id: form_link_data.form_id,
        type_val: form_link_data.form_name,
        form_link_conf: form_link_data,
        form_link_status: true
      }
      }
      else{
         view_form_obj = {
          active:true,
          type:'form',
          type_id: form_link_data.par_form_id,
          type_val: form_link_data.form_name,
          form_link_data: null
        }
        }
        if(form_link_data.skip_primary == true){
          view_form_obj['type_val'] = ''
        }
    setPageData((page_data)=>{
      const newPageData = { ...page_data };
      newPageData.sections[section_index][comp_type].push(view_form_obj)
      return newPageData;
    })
  }


 
 const close_forms = (section_indx, comp_type) =>{
    // console.log('whole length :: ',page_data.sections[section_indx][comp_type].length)
    // console.log('SECT INFO :: ',page_data.sections[section_indx])
    let first_view_obj = page_data.sections[section_indx][comp_type][0]//initial view or widget object 
    set_first_obj(first_view_obj)
    // set_initial_state(first_view_obj,section_indx,comp_type
    const section_length = page_data.sections[section_indx][comp_type].length
    for(let i = 0;i<section_length ;i++){
      setPageData((page_data) => {
        // Create a shallow copy of the previous state
        const newPageData = { ...page_data };   
        newPageData.sections[section_indx][comp_type].pop();
        // console.log('section length :: ',section_length)
          if(i == section_length-1){
            // console.log('check i :: ',i)
            // newPageData.sections[section_indx][comp_type].push(first_view_obj)
          }
        return newPageData;
      }); 
    }
  }



  function CloseWidget(section_index,comp_type,comp_indx){
    //console.log("\n\nclose executed");
    setPageData((page_data) => {
      // Create a shallow copy of the previous state
      const newPageData = { ...page_data };
  
      // false the 'active' property for the specified widget
      newPageData.sections[section_index][comp_type][comp_indx].active = false;
  
      // Return the updated state
      return newPageData
    });

  }
  const enable_widget = (sect_indx,widg_indx) => {
    //console.log("on widget open :: ",page_data,sect_indx,widg_indx)
    // setFormLoading(false)
    disable_remainig_widget(sect_indx,widg_indx)
    setPageData((page_data) => {
      // Create a shallow copy of the previous state
      const newPageData = { ...page_data };
      // Toggle the 'active' property for the specified widget
      newPageData.sections[sect_indx].widgets[widg_indx].active = !newPageData.sections[sect_indx].widgets[widg_indx].active;
      return newPageData;
    });
  };

  const enable_view = (sect_indx,view_indx) => {
    //console.log("on view open :: ",page_data,sect_indx,view_indx)
    // disable_remainig_view(sect_indx,view_indx)
    page_data.sections[sect_indx].views[view_indx].active = !page_data.sections[sect_indx].views[view_indx].active;
  };

  const disable_remainig_widget = (sect_indx,except_widg_index) => {
    for(let j = 0;j < page_data.sections[sect_indx].widgets.length;j++){
      if(j !== except_widg_index){
        page_data.sections[sect_indx].widgets[j]['active'] = false;
      }
    }
  };

  const disable_remainig_view = (sect_indx,except_view_index) => {
    for(let j = 0;j < page_data.sections[sect_indx].views.length;j++){
      if(j !== except_view_index){
        page_data.sections[sect_indx].views[j]['active'] = false;
      }
    }
  }

  const toggle_section = (sect_indx) => {
    page_data.sections[sect_indx].active = !page_data.sections[sect_indx].active;
  }
 
  const navigate = useNavigate();


  function back_to_home(){
    // navigate('/layout/UsecaseList')
    try {
      const data = {
        token: localStorage.getItem('vector_token'),
        search_key: searchKey,
        selected_usecase: {}
        }
        testhttpClient.post('/get_usecase_dashboard_map_list',data).then(response=>{
        if(response.data.status == true){
          //console.log('usecase data :: ',response.data.data)
          if(response.data.data.length==1 && response.data.data[0].usecase_id == -1){
            navigate('/layout/DashboardList');
          }
          else{
            navigate('/layout/UsecaseList');
          }
        }
        else{
          //console.log('failed response :: ',response)
        }
      }).catch(error => {
        console.error('Error:', error);
        // setLoading(false);
      });
    }catch (error) {
      //console.log('outer error :: ',error)
      // setLoading(false);
      // Handle network or other errors
    } 
  }

  function disableWidgetorView(section_index,comp_type,comp_indx){
    setPageData((page_data) => {
      // Create a shallow copy of the previous state
      const newPageData = { ...page_data };
      // false the 'active' property for the specified widget
      newPageData.sections[section_index][comp_type][comp_indx].disabled = true;
      // Return the updated state
      return newPageData
    });
  }


  
  function toggleFullscreen() {
    setFullScreenMode(!fullScreenMode);
  }

  return (
    <div key={curr_page_id}  className='outerMostContainer' id='outerMostContainer'>
      {/* to test notification */}
      {/* <Button onClick={() => ShowNotification({ noti_vertical: 'top', noti_horizontal: 'right', notiMessage: 'error captured',notiSeverity : 'error' })}>
        Top-Right
      </Button> */}
      <Snackbar
        anchorOrigin={{ vertical :noti_vertical, horizontal: noti_horizontal }}
        open={noti_open}
        autoHideDuration={duration_in_sec}
        onClose={() => CloseNotification()}
        message={notiMessage}
        key={noti_vertical + noti_horizontal}
        style={{zIndex:2500}}
      >
        <Alert onClose={() => CloseNotification()} severity={notiSeverity} sx={{ width: '100%' }}>
          {notiMessage}
        </Alert>
      </Snackbar>
      {(!loading1) ? (
        page_data.sections.map((sect_data, sect_indx) => (
          <div key={sect_indx} id='sect_index_key'>
            {
              sect_data.active ? (
                <div id='sect_name' >
                  {/* <Divider>{sect_data.name}</Divider> */}
                  <Grid>
                    <div className='sectionName' id='sectionName'>
                    <Fab size="small" style={{backgroundColor:'white',marginRight:'10px',bottom:'3px',marginLeft:'4px'}}  onClick={() => back_to_home()}>
                      <ArrowBackOutlinedIcon sx={{color:'#4D4D4D'}}/>
                    </Fab>
                      {sect_data.name}
                    </div>
                  </Grid>

                  {/* <div className='sectionName'>{sect_data.name}</div> */}
                  {/* <div className='widgetContainer' id='widgetContainer'>
                    <Grid container spacing={2} sx={{marginTop:'5px'}}>
                      {
                        sect_data.widgets.map((each_widget,widg_indx) => (
                          <Grid item  key={each_widget.type_id}>
                            {(!(each_widget?.form_link_status))?(
                              <Button key={widg_indx}
                              className={`Button ${each_widget.active ? 'selected' : ''}`}
                                sx={{'font-family': 'Montserrat','font-style': 'normal','font-weight': '600','font-size': '13px','line-height': '20px',display: 'flex','align-items': 'center','text-align': 'center',backgroundColor : 'white', color: 'black','border-radius': '200px',border: 'none !important',transition: '0.3s ease',color:'#4D4D4D',boxShadow: '0px 0px 4px 0px #00000040',padding:'3px 15px',width: 'fit-content','&:hover': {
                                backgroundColor: each_widget.active ? '#0077CC' :'#65CCFF', // Adjust the alpha value to control transparency
                                color: 'white'
                                } }} onClick={() => enable_widget(sect_indx,widg_indx)}>
                                { each_widget.type_val } */}
                  {sect_data.widgets && sect_data.widgets.length > 0 && (
                    <div className='widgetContainer' id='widgetContainer'>
                      <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                        {sect_data.widgets.map((each_widget, widg_indx) => (
                          !each_widget?.form_link_status && (
                            <Grid item key={each_widget.type_id}>
                              <Button
                                key={widg_indx}
                                className={`Button ${each_widget.active ? 'selected' : ''}`}
                                sx={{
                                  fontFamily: 'Montserrat',
                                  fontStyle: 'normal',
                                  fontWeight: '600',
                                  fontSize: '13px',
                                  lineHeight: '20px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  textAlign: 'center',
                                  backgroundColor: 'white',
                                  color: 'black',
                                  borderRadius: '200px',
                                  border: 'none !important',
                                  transition: '0.3s ease',
                                  color: '#4D4D4D',
                                  boxShadow: '0px 0px 4px 0px #00000040',
                                  padding: '3px 15px',
                                  width: 'fit-content',
                                  '&:hover': {
                                    backgroundColor: each_widget.active ? '#0077CC' : '#65CCFF', // Adjust the alpha value to control transparency
                                    color: 'white',
                                  },
                                }}
                                onClick={() => enable_widget(sect_indx, widg_indx)}
                              >
                                {each_widget.type_val}
                                {each_widget.active ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                              </Button>
                            </Grid>
                          )
                        ))}
                      </Grid>
                    </div>
                  )}

                  <div >
                  {  
                        sect_data.widgets.map((each_widget,widg_indx2) => (
                          each_widget.active ? (
                            <div key={each_widget.type_id}  className={`${each_widget?.disabled ? 'widgetContainer_disable' : 'widgetContainer'}`} id={`${each_widget?.disabled ? 'widgetContainer_disable' : 'widgetContainer'}`}>
                                {each_widget.type  === 'form' ? (
                                  <div id='widget_chattemplate'> 
                                    <ChatTemplate trigger_form_data={each_widget} trigger_section_index={sect_indx} trigger_comp_type={'widgets'} trigger_comp_index={widg_indx2} CloseWidget={CloseWidget} triggerNotification={triggerNotification} toggleFullscreen={toggleFullscreen} submit_form = {submit_form}  setSectionIndex={setSectionIndex} setCompType={setCompType} triggerCloseForms_check={setTriggerCloseForms} disableWidgetorView={disableWidgetorView} />
                                  </div>
                                ): null}
                                {each_widget.type  !== 'form' ? (
                                  <div id='widget_chattemplate!form'>
                                      <EmbedView extLinkId={each_widget.type_id} trigger_section_index={sect_indx} trigger_comp_type={'widgets'} trigger_comp_index={widg_indx2} />
                                  </div>
                                ): null}
                            </div>
                          ):null
                        ))
                      }
                  </div>          
                    {
                      (!loading1) ? (
                      sect_data.views.map((each_view,view_indx) => (
                        <div  className={`${each_view?.disabled ? 'ViewContainer_disable' : 'ViewContainer'}`} key={each_view.type_id} id={`${each_view?.disabled ? 'ViewContainer_disable' : 'ViewContainer'}`}>
                          { each_view.active ? (
                          <div id='views_form' >
                              { each_view.type === 'form' ? (
                                <>
                                  <div className={`${fullScreenMode ? 'fullscreen-div' : ''}`} id={`${fullScreenMode ? 'fullscreen-div' : ''}`}>
                                    <ChatTemplate key={'view_' + each_view.type_id} trigger_form_data={each_view} trigger_section_index={sect_indx} trigger_comp_type={'views'} trigger_comp_index={view_indx} CloseWidget={CloseWidget} triggerNotification={triggerNotification} toggleFullscreen={toggleFullscreen} submit_form = {submit_form}  setSectionIndex={setSectionIndex} setCompType={setCompType} triggerCloseForms_check={setTriggerCloseForms} disableWidgetorView={disableWidgetorView}/>
                                  </div>
                                </>
                              ):null}
                              { each_view.type !== 'form' ? (
                              <div id='views_!form' >
                                  <div id='embed_view'>
                                      <EmbedView extLinkId={each_view.type_id} trigger_section_index={sect_indx} trigger_comp_type={'views'} trigger_comp_index={view_indx}/>
                                  </div>
                              </div>
                              ): null}
                          </div>
                          ) : (
                          <div style={{textAlign : 'center'}} id='view_type_val'>
                              {each_view.type_val}
                          </div>
                          )}
                        </div>
                      ))
                      ):(null)
                    }
                    {
                      (!loading1) ? (
                      sect_data.batch_workflow.map((each_batch_workflow,batch_workflow_indx) => (
                        <div key={each_batch_workflow.type_id}>
                          { each_batch_workflow.active ? (
                          <div >
                              { each_batch_workflow.type === 'batch' ? (
                                <>
                                  <div className={`${fullScreenMode ? 'fullscreen-div' : ''}`}>
                                    <Batch key={'view_' + each_batch_workflow.type_id} trigger_form_data={each_batch_workflow} trigger_section_index={sect_indx} trigger_comp_type={'batch_workflow'} trigger_comp_index={batch_workflow_indx} CloseWidget={CloseWidget} triggerNotification={triggerNotification} toggleFullscreen={toggleFullscreen} submit_form = {submit_form}  setSectionIndex={setSectionIndex} setCompType={setCompType} triggerCloseForms_check={setTriggerCloseForms} disableWidgetorView={disableWidgetorView} batch_id={each_batch_workflow.type_id}/>
                                  </div>
                                </>
                              ):null}
                          </div>
                          ) : (
                          <div style={{textAlign : 'center'}}>
                              {each_batch_workflow.type_val}
                          </div>
                          )}
                        </div>
                      ))
                      ):(null)
                    }
                  {/* ###KANISH## - 
                  1) create new component for batch list view - (Active/completed batches)(page route - '/batch-list-view/batchId')
                      - <BatchListView />
                      - API to get batch list(pass - batch id) with search 
                          - (url - '/get_batch_list') 
                          - get response 
                              - {"status":True,"data":{
                                               "active":[
                                                   {
                                                       "batch taks id": 123,
                                                       "batch task name": "sample",
                                                       "batch cf 1": "dummy",
                                                       "batch cf 2": "dummy",
                                                       "stage": "current stage",
                                                       "status": "active",
                                                   }]
                                               ,
                                               "Complete":[
                                                   {
                                                       "batch taks id": 123,
                                                       "batch task name": "sample",
                                                       "batch cf 1": "dummy",
                                                       "batch cf 2": "dummy",
                                                       "stage": "current stage",
                                                       "status": "complete",
                                                   }]
                                               }}
                          - if no batch so empty(no rec found)
                  2) cretae new component for batch stage view - (batch stages horizontal view)(page route - '/batch-stage-view/batchId') add batch task id
                    - <BatchStageView />
                    - API to get batch Entire details(pass - batch id,batch task id)
                          - (url - '/get_batch_data') 
                          - get response - {"status":True,"data":{
                                                             "batch details" : {
                                                                 "stage_list" : [{
                                                                     "index_code": 1,
                                                                     "stage name": "smaple",
                                                                     "form id": 3212,
                                                                     "user access": // {1: view, 2: No view, 3: Hide,4: View progress, 5:Edit },
                                                                     "stage lock" : // {0 or 1}
                                                                 }]
                                                             },
                                                             batch task details : {
                                                                 "batch task id": 3213,
                                                                 "current stage": "stage 1",
                                                             }
                                                         }
                                                 }
                          - if no stages so empty(no stage found)                DONE
                          - Batch name as header
                          - horizontal stage iteration - ""Stage List"" 
                            - filter stage alone   (NOT)
                            - disable stage as per access('batch_stage_access' - {1: view, 2: No view, 3: Hide,4: View progress, 5:Edit }, 'batch_stage_lock_access' - '1/0')
                            view -- form visible but no edit
                            no view -- cannot able to click the stage
                            hide -- hide the stage tab
                            view progress -- only show the count(active/complete)
                            edit -- normal
                            - use <chatemplates> to show forms(pass special params to indigate its a 'batch' - purposes task access/treat special case on form submit)
                            - manual stage lock
                              - API ('/manual-stage-lock')(params - batchId,stage/stageId)
                              - stage complete notification
                              - refresh same stage
                            - View Access
                              - in chat template
                                - each row it CURR_MULTI_SUBFORM_TEMP, each_row, ques[0] - first quest - 'tracker status' - '0/1'
                            - Form submit(include batch id,stahe id/ stage name,batch task id)
                  */}
                </div>
              ) : null 
            }
          </div>
        ))
      ):(
        <LinearProgress />
      )
      }

    </div>
  );
}

OpenDashboard.propTypes = {};

OpenDashboard.defaultProps = {};

export default OpenDashboard;
